import React from "react";
import { Checkbox } from "antd";

import { cloneData,bajajCloneData } from "./validation";
const CheckboxComponent = (props) => {
  const { field, formData,fullData,formValues, form, placeholder } = props;
  const { value, name } = field;

  const { setFieldValue, values, handleBlur, validateForm } = form;

  return (
    <Checkbox
      checked={value}
      onBlur={handleBlur(name)}
      onChange={(status) => {
        setFieldValue(name, status.target.checked);

        if (status.target.checked) {
          cloneData.map((clone) => {
            let mainfield = formData.filter(
              (formItem) => formItem.code == clone.main
            );

            if (mainfield && mainfield.length > 0) {
              const dependedField = formData.filter(
                (formItem) => formItem.code == clone.depended
              );
              if (dependedField && dependedField.length > 0) {
                setFieldValue(
                  `${dependedField[0].id}`,
                  values[`${mainfield[0].id}_name_`]
                    ? values[`${mainfield[0].id}_name_`]
                    : values[`${mainfield[0].id}`]
                );
              }
            }
          });
          // if(bajajCloneData && fullData && formValues){
          // bajajCloneData.map((clone) => {
          // if(fullData && fullData[133] && fullData[134] && formValues[133]){
          //   const bajajData = fullData[133];
          //   const bajajDataClone= fullData[134];
          //   const bajajValues = formValues[133];

          //   if(bajajData && bajajDataClone) {
          //   let mainfield = bajajData.filter(
          //     (formItem) => formItem.code == clone.main
          //   );

          //   if (mainfield && mainfield.length > 0) {
          //     const dependedField = bajajDataClone.filter(
          //       (formItem) => formItem.code == clone.depended
          //     );
          //     if (dependedField && dependedField.length > 0) {
          //       setFieldValue(
          //         `${dependedField[0].id}`,
          //         bajajValues[`${mainfield[0].id}_name_`]
          //           ? bajajValues[`${mainfield[0].id}_name_`]
          //           : bajajValues[`${mainfield[0].id}`]
          //       );
          //       setTimeout(()=>{
          //         validateForm();
          //       })
          //     }
          //   }
          //   }
          //  }
          //  });
          // }


          if(bajajCloneData){
            bajajCloneData.map((clone) => {
              let mainfield = formData.filter(
                (formItem) => formItem.code == clone.main
              );
  
              if (mainfield && mainfield.length > 0) {
                const dependedField = formData.filter(
                  (formItem) => formItem.code == clone.depended
                );
                if (dependedField && dependedField.length > 0) {
                  setFieldValue(
                    `${dependedField[0].id}`,
                    values[`${mainfield[0].id}_name_`]
                      ? values[`${mainfield[0].id}_name_`]
                      : values[`${mainfield[0].id}`]
                  );
                  setTimeout(()=>{
                    validateForm();
                  })
                }
              }
            });
          }
        }
      }}
    >
      {placeholder}
    </Checkbox>
  );
};

export default CheckboxComponent;
